/*
 * 1DS JS SDK Properties plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* Sdk.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { newGuid, safeGetCookieMgr, getCookieValue, random32 } from "@microsoft/1ds-core-js";
var DEVICE_ID_COOKIE = "MicrosoftApplicationsTelemetryDeviceId";
function _saveData(mgr, propertyStorage, name, value) {
    if (propertyStorage) {
        propertyStorage.setProperty(name, value);
    }
    else {
        // Expires in 365 days (365 * 24 * 60 * 60)
        mgr.set(name, value, 31536000);
    }
}
function _getData(mgr, propertyStorage, name) {
    if (propertyStorage) {
        return propertyStorage.getProperty(name) || "";
    }
    return getCookieValue(mgr, name);
}
var Sdk = /** @class */ (function () {
    function Sdk(coreConfig, core) {
        this._sequenceId = 0;
        var propertyStorage = coreConfig.propertyStorageOverride;
        // Start sequence
        this.seq = this._sequenceId;
        this.epoch = random32(false).toString();
        var mgr = safeGetCookieMgr(core, coreConfig);
        if (mgr.isEnabled() || propertyStorage) {
            // Only collect device id if it can be stored
            var deviceId = _getData(mgr, propertyStorage, DEVICE_ID_COOKIE);
            if (!deviceId) {
                deviceId = newGuid();
            }
            _saveData(mgr, propertyStorage, DEVICE_ID_COOKIE, deviceId);
            this.installId = deviceId;
        }
        else {
            mgr.purge(DEVICE_ID_COOKIE);
        }
    }
    // Get seq value
    Sdk.prototype.getSequenceId = function () {
        return ++this._sequenceId;
    };
    return Sdk;
}());
export { Sdk };
//# sourceMappingURL=Sdk.js.map